import RGBaster from '@/lib/rgbaster';

import {
  find,
  isNil,
  defaultTo,
  head,
  replace,
  orderBy,
  overEvery,
  negate,
  compact,
  filter,
} from 'lodash';

export const URLS = {
  defaultRedirect: `${process.env.VUE_APP_DEFAULT_REDIRECT}`,
};

export function getAttributeValueFrom(htmlString, attribute) {
  let attributeValue;
  // obtener el atributo en forma attribute="value"
  attributeValue = head(htmlString.match(new RegExp(`${attribute}="([^"]*)"`)));
  // eliminar attribute="
  attributeValue = replace(attributeValue, new RegExp(`${attribute}="`), '');
  // eliminar " finales
  attributeValue = replace(attributeValue, /"/, '');
  return attributeValue;
}

function getPropertyFromProjects(property, projects) {
  let project = find(projects, {
    type: 'CRD',
  });

  if (isNil(project)) {
    project = find(projects, _project => !isNil(_project[property]));
  }

  project = defaultTo(project, {
    [property]: '',
  });

  return project[property];
}

export function getDescriptionFromProjects(projects) {
  return getPropertyFromProjects('description', projects);
}

export function getColorsFromSrc(src) {
  return new Promise((resolve, reject) => {
    try {
      RGBaster.colors(src, {
        success(payload) {
          resolve(payload);
        },
      });
    } catch (e) {
      reject(e);
    }
  });
}

export function hexToRgbA(hex, a) {
  /* eslint-disable */
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');
    return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + a + ')';
  }
  throw new Error('Bad Hex');
  /* eslint-enable */
}

export function highlightWord(word, toHightLight) {
  // https://stackoverflow.com/a/37511463
  const wordWithoutDiacritics = word.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  // g global / m multiline / i ignore case
  const regexp = new RegExp(toHightLight, 'gmi');
  const hightlighted = wordWithoutDiacritics.replace(regexp, match => `<mark>${match}</mark>`);

  return hightlighted;
}

export function getMessageFromUnauthorizedEntity(unauthorizedEntity) {
  switch (unauthorizedEntity) {
    case 'USER-INCORRECT_USERNAME_OR_PWD':
      return 'Usuario o password incorrecto';
    case 'USER-PWD_EXPIRED':
      return 'Contraseña caducada';
    default:
      return 'Acceso denegado';
  }
}

export function unauthorizedEntityIsPasswordExpired(unauthorizedEntity) {
  return unauthorizedEntity === 'USER-PWD_EXPIRED';
}

export function projectIsTest(project) {
  return /test/i.test(project.name);
}

export function getSlottedProjects(projects) {
  const orderedProjects = orderBy(projects, 'id');

  const projectTypeIsCrd = project => project.type === 'CRD';
  const projectTypeIsIwrs = project => project.type === 'IWRS';
  const projectTypeIsCrdAndIsTest = overEvery(projectTypeIsCrd, projectIsTest);
  const projectTypeIsIwrsAndIsTest = overEvery(projectTypeIsIwrs, projectIsTest);
  const projectTypeIsCrdAndIsNotTest = overEvery(projectTypeIsCrd, negate(projectIsTest));
  const projectTypeIsIwrsAndIsNotTest = overEvery(projectTypeIsIwrs, negate(projectIsTest));

  const tmfSlot = find(orderedProjects, { type: 'TMF' });
  const crdSlot = find(orderedProjects, projectTypeIsCrdAndIsNotTest);
  const crdTestSlot = find(orderedProjects, projectTypeIsCrdAndIsTest);
  const iwrsSlot = find(orderedProjects, projectTypeIsIwrsAndIsNotTest);
  const iwrsTestSlot = find(orderedProjects, projectTypeIsIwrsAndIsTest);
  const cmiSlot = find(orderedProjects, { type: 'CMI' });
  const erpSlot = find(orderedProjects, { type: 'ERP' });
  const eventsPlatformSlot = find(orderedProjects, { type: 'EVENTS-PLATFORM' });
  const nexusSlot = find(orderedProjects, { type: 'NEXUS' });

  return compact([
    tmfSlot, crdSlot, iwrsSlot, cmiSlot, crdTestSlot, iwrsTestSlot,
    erpSlot, eventsPlatformSlot, nexusSlot,
  ]).map(slot => ({
    ...slot,
    projects: filter(projects, { id: slot && slot.id }),
    selected: null,
  }));
}
